export default {
  table: {
    '& th': {
      textAlign: 'left'
    }
  },
  schoolLeadCell: {
    textAlign: 'center !important'
  }
}
